import { NgModule } from '@angular/core';
import { ModusDatePickerDirective } from './modus-date-picker.directive';

@NgModule({
  declarations: [ModusDatePickerDirective],
  exports: [ModusDatePickerDirective],
})
export class ModusDatePickerModule {}
